import statusProcesso from '@/constants/statusProcessosCentral'
import estadosCivilGeral from '@/constants/estadoCivil'
import PERFIL from '@/constants/perfil'
import _ from 'lodash'
const { setores, nomesSetores } = require('./setor').default

const perfis = [
  PERFIL.RECEPTOR.RECEPTOR.codigo,
  PERFIL.RECEPTOR.RECEPTOR_EXTERNO.codigo
]

const setStatus = (prop) => {
  if (prop.setor === setores.GAC && prop.status === 'AGUARDANDO_ANALISE') return 'Aguardando análise'

  if (prop.status !== 'FINALIZADO' || prop.status !== 'ARQUIVADO') return 'Em análise'

  const status = _.find(statusProcesso, sts => sts.codigo === prop)
  return status ? status.nome : '-'
}

const setSetor = (prop) => {
  switch (prop) {
    case setores.PROTOCOLO:
      return nomesSetores.PROTOCOLO
    case setores.JURIDICO:
      return nomesSetores.JURIDICO
    case setores.DRF:
      return nomesSetores.DRF
    case setores.DF1:
      return nomesSetores.DF1
    case setores.DF3:
      return nomesSetores.DF3
    case setores.COMISSAO_ILHA:
      return nomesSetores.COMISSAO_ILHA
    case setores.DATGL:
      return nomesSetores.DATGL
    case setores.PRESIDENCIA:
      return nomesSetores.PRESIDENCIA
    case setores.CAF:
      return nomesSetores.CAF
    case setores.CAS:
      return nomesSetores.CAS
    case setores.CTT:
      return nomesSetores.CTT
    case setores.DADR:
      return nomesSetores.DADR
    case setores.CEP:
      return nomesSetores.CEP
    case setores.DAF:
      return nomesSetores.DAF
    case setores.CADR:
      return nomesSetores.CADR
    case setores.DUF:
      return nomesSetores.DUF
    case setores.DEO:
      return nomesSetores.DEO
    case setores.DUA:
      return nomesSetores.DUA
    case setores.DGRH:
      return nomesSetores.DGRH
    case setores.DMP:
      return nomesSetores.DMP
    case setores.PRODUTIVIDADE:
      return nomesSetores.PRODUTIVIDADE
    case setores.RELATORIOS:
      return nomesSetores.RELATORIOS
    case setores.FINANCEIRO:
      return nomesSetores.FINANCEIRO
    case setores.GOVERNO:
      return nomesSetores.GOVERNO
    case setores.PARAMETRIZACAO:
      return nomesSetores.PARAMETRIZACAO
    default: return '-'
  }
}

const estadosCivil = estadosCivilGeral.filter(e => e.codigo !== 'UNIAO_HOMOAFETIVA' && e.codigo !== 'SEPARADO')

const labelsCadastro = {
  imovel: {
    denominacao: 'Denominação do imóvel:',
    colonia: 'Nome da gleba:',
    lote: 'N° do processo:'
  },
  interessado: {
    prefeitura: 'Órgão publico:',
    cpfPrefeito: 'CPF do principal gestor:',
    nomePrefeito: 'Nome do principal gestor:'
  },
  endereco: 'Endereço do órgão público'
}

const inputsExtraCadastro = {
  imovel: {
    dataMatricula: true,
    nomeImovelPropriedade: true,
    numeroTitulo: false,
    escrituraDocumentoRegistro: true
  },
  georreferencia: {
    texto: true
  }
}

const georreferenciamentoSigef = false

const notificacaoWhatsApp = false

const buttonOpcoes = {
  showButonVisualizarProcesso: true
}

const switchHabilitar = {
  showSwitchHabilitar: false
}

const showButtonOficio = false

const tiposProcessos = [
  {
    codigo: 'NAO_ONEROSO',
    nome: 'Alienação simples doação'
  },
  {
    codigo: 'ONEROSO',
    nome: 'Alienação Simples Onerosa'
  }
]

const tipoDocumentos = []

const tiposProcessosFisicos = []

const tiposArea = []

const filtroDefaultNumeroRecibo = () => {
  return [...perfis]
}

const filtroDefaultSituacao = () => {
  return [...perfis]
}

const filtro = {
  placeholder: 'Número do processo, Nome/Razão social do Interessado, CPF/CNPJ do interessado, ou Tipo do processo',
  showFiltroTipoProcessoMultiplo: false,
  filtroNumeroRecibo: {
    LISTAGEM_RECEPTOR_CADASTROS_PENDENTES: filtroDefaultNumeroRecibo()
  },
  filtroSituacao: {
    LISTAGEM_RECEPTOR_CADASTROS_PENDENTES: filtroDefaultSituacao()
  }
}

const sendMessageToReoplay = (confirmMessage, titleMessage, message, send) => {
  send()
}

export default {
  setSetor,
  setStatus,
  estadosCivil,
  labelsCadastro,
  inputsExtraCadastro,
  georreferenciamentoSigef,
  notificacaoWhatsApp,
  buttonOpcoes,
  switchHabilitar,
  showButtonOficio,
  tiposProcessos,
  tipoDocumentos,
  tiposProcessosFisicos,
  tiposArea,
  filtro,
  sendMessageToReoplay
}



// WEBPACK FOOTER //
// ./src/utils/ba/regrasCentral.js